<p-treeSelect 
  class="w-full products-tree-select" 
  containerStyleClass="w-full" 
  [(ngModel)]="selectedNodes" 
  [options]="treeNodes" 
  [metaKeySelection]="false"
  [selectionMode]="selectionMode"
  placeholder="Select Brands"
  [filter]="true"
  filterBy="label"
  (onNodeSelect)="onNodeSelect($event)"
  (onNodeUnselect)="onNodeUnselect($event)"
  (onClick)="onTreeClick($event)"
  appendTo="body"
  [showClear]="true"
  display="chip"
>
  <!-- Tree node rendering in dropdown -->
  <ng-template let-node pTemplate="item">
    <span 
      [class]="'tree-node-' + node.data?.type"
      [id]="node.data?.productId || node.key"
      (click)="onNodeClick(node, $event)"
    >
      {{ node.label }}
    </span>
  </ng-template>

  <!-- Chip label customization -->
  <ng-template let-value pTemplate="value">
    <ng-container *ngIf="selectionMode === 'single'; else multipleTemplate">
      <span class="custom-chip" *ngIf="value?.data">
        {{ value.data.productType || value.label }}
      </span>
    </ng-container>
    
    <ng-template #multipleTemplate>
      <ng-container *ngIf="selectedNodes?.length > 0; else placeholderTemplate">
        <span 
          class="custom-chip" 
          *ngFor="let node of selectedNodes; let i = index"
        >
          {{ node?.data?.productType || node.label }}
          <span *ngIf="i < selectedNodes.length - 1">, </span>
        </span>
      </ng-container>
    </ng-template>

    <!-- Placeholder fallback if empty (optional but helps ensure visible placeholder) -->
    <ng-template #placeholderTemplate>
      <span class="custom-placeholder">Select Brands</span>
    </ng-template>
  </ng-template>
</p-treeSelect>
